import type { PathType } from './types';
import { getPath } from './types';

export const masterDataPaths: { [key: string]: PathType } = {
  employee: getPath('/interactive/system-admin/employee', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee'
  ]),
  employeeAdd: getPath('/interactive/system-admin/employee/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'action.add'
  ]),
  employeeQR: getPath('/interactive/system-admin/employee/qr', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'action.getQR'
  ]),
  employeeEdit: getPath('/interactive/system-admin/employee/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'action.edit'
  ]),
  employeeDetail: getPath('/interactive/system-admin/employee/detail', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employee',
    'page.detail'
  ]),
  department: getPath('/interactive/system-admin/department', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.department'
  ]),
  branch: getPath('/interactive/system-admin/branch', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.branch'
  ]),
  position: getPath('/interactive/system-admin/position', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.position'
  ]),
  board: getPath('/interactive/system-admin/board', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.board'
  ]),
  level: getPath('/interactive/system-admin/level', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.level'
  ]),
  tier: getPath('/interactive/system-admin/tier', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.tier'
  ]),
  jobCategory: getPath('/interactive/system-admin/job-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.jobCategory'
  ]),
  jobCategoryAdd: getPath('/interactive/system-admin/job-category/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.jobCategory',
    'action.add'
  ]),
  jobCategoryEdit: getPath('/interactive/system-admin/job-category/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.jobCategory',
    'action.edit'
  ]),
  organizationChart: getPath('/interactive/system-admin/organization-chart', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.organizationChart'
  ]),
  asset: getPath('/interactive/system-admin/asset', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.asset'
  ]),
  degree: getPath('/interactive/system-admin/degree', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.degree'
  ]),
  partnerType: getPath('/interactive/system-admin/partner-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partnerType'
  ]),
  partner: getPath('/interactive/system-admin/partner', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partner'
  ]),
  partnerAdd: getPath('/interactive/system-admin/partner/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partner',
    'action.add'
  ]),
  partnerEdit: getPath('/interactive/system-admin/partner/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.partner',
    'action.edit'
  ]),
  accountingAccountType: getPath('/interactive/system-admin/accounting-account-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.accountingAccountType'
  ]),
  generalAccountingAccount: getPath('/interactive/system-admin/general-accounting-account', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.generalAccountingAccount'
  ]),
  employeeContract: getPath('/interactive/system-admin/employee-contract', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.employeeContract'
  ]),
  contractType: getPath('/interactive/system-admin/contract-type', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.contractType'
  ]),
  applicationInfo: getPath('/interactive/system-admin/application-info', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo'
  ]),
  applicationInfoAdd: getPath('/interactive/system-admin/application-info/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo',
    'action.add'
  ]),
  applicationInfoEdit: getPath('/interactive/system-admin/application-info/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo',
    'action.edit'
  ]),
  applicationInfoDetail: getPath('/interactive/system-admin/application-info/detail', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.applicationInfo',
    'page.detail'
  ]),
  certificate: getPath('/interactive/system-admin/certificate', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.certificate'
  ]),
  errorCode: getPath('/interactive/system-admin/error-code', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.errorCode'
  ]),
  hrTicketCategory: getPath('/interactive/system-admin/hr-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.hrTicketCategory'
  ]),
  resource: getPath('/interactive/system-admin/resource', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.resource'
  ]),
  role: getPath('/interactive/system-admin/role', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.role'
  ]),
  roleAdd: getPath('/interactive/system-admin/role/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.role',
    'action.add'
  ]),
  roleEdit: getPath('/interactive/system-admin/role/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.role',
    'action.edit'
  ]),
  userResource: getPath('/interactive/system-admin/user-resource', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userResource'
  ]),
  userResourceAdd: getPath('/interactive/system-admin/user-resource/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userResource',
    'action.add'
  ]),
  userResourceEdit: getPath('/interactive/system-admin/user-resource/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userResource',
    'action.edit'
  ]),
  permission: getPath('/interactive/system-admin/permission', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.permission'
  ]),
  distance: getPath('/interactive/system-admin/distance', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.distance'
  ]),
  holiday: getPath('/interactive/system-admin/holiday', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.holiday'
  ]),
  fuelConsumption: getPath('/interactive/system-admin/fuel-consumption', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.fuelConsumption'
  ]),
  fuelUnitPrice: getPath('/interactive/system-admin/fuel-unit-price', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.fuelUnitPrice'
  ]),
  subSystem: getPath('/interactive/system-admin/sub-system', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.subSystem'
  ]),
  subSystemAdd: getPath('/interactive/system-admin/sub-system/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.subSystem',
    'action.add'
  ]),
  subSystemEdit: getPath('/interactive/system-admin/sub-system/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.subSystem',
    'action.edit'
  ]),
  workDescription: getPath('/interactive/system-admin/work-description', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.workDescription'
  ]),
  userTicketCategory: getPath('/interactive/system-admin/user-ticket-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userTicketCategory'
  ]),
  userJobCategory: getPath('/interactive/system-admin/user-job-category', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.userJobCategory'
  ]),
  shift: getPath('/interactive/system-admin/shift', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.shift'
  ]),
  managerAssignment: getPath('/interactive/system-admin/manager-assignment', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.managerAssignment'
  ]),
  wareHouse: getPath('/interactive/system-admin/ware-house', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.wareHouse'
  ]),
  mobileVersion: getPath('/interactive/system-admin/mobile-versions', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.mobileVersion'
  ]),
  productionUnit: getPath('/interactive/system-admin/production-unit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionUnit'
  ]),
  productionUnitAdd: getPath('/interactive/system-admin/production-unit/add', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionUnit',
    'action.add'
  ]),
  productionUnitEdit: getPath('/interactive/system-admin/production-unit/edit', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.productionUnit',
    'action.edit'
  ]),
  acceptancePermission: getPath('/interactive/system-admin/acceptance-permission', [
    'v2.sidebar.home',
    'sidebar.master-data.index',
    'sidebar.master-data.acceptancePermission'
  ])
};
